export const STATE = 'Karnataka';

export const DISTRICTS = [
    'Bengaluru Urban', 'Bengaluru Rural', 'Chikkaballapura',
    'Chitradurga', 'Davanagere', 'Kolar', 'Ramanagara',
    'Shivamogga (Shimoga)', 'Tumakuru', 'Bagalkote', 'Belagavi',
    'Dharwad', 'Gadag', 'Haveri', 'Uttara Kannada (Karwar)',
    'Vijayapura (Bijapur)', 'Ballari (Bellary)', 'Bidar',
    'Kalaburagi (Gulbarga)', 'Koppal', 'Raichur', 'Vijayanagara',
    'Yadgir', 'Chamarajanagara', 'Chikkamagaluru',
    'Dakshina Kannada (Mangaluru)', 'Hassan', 'Kodagu (Coorg)',
    'Mandya', 'Mysuru', 'Udupi'
];

export const CATEGORIES = [
    'Bangalore Metro TV News', 'Interviews', 'Politics', 'Civic', 'Corporate & Economy', 'Science & Technology',
    'Health', 'Education', 'Sports', 'Entertainment', 'Lifestyle',
    'Religion & Culture', 'Environment', 'Crime, Law & Order',
    'Judicial', 'Agriculture & Rural Development', 'Defence & Security',
    'Automotive', 'Real Estate', 'Career & Employment'
];